import React from 'react';
import PropTypes from 'prop-types';
import { Router, Redirect } from '@reach/router';
/**
 * variator for cases when routing unneeded
 */

export default function RouteVariator({ noRoute, children, redirectUrl, activeSlug }) {
  if (noRoute) {
    const renderChildren = React.Children.toArray(children);
    return <>{renderChildren.filter((child) => child.props.slug === activeSlug)}</>;
  }
  return (
    <Router basepath="/" primary={false}>
      {children}
      <Redirect from="*" to={redirectUrl} default noThrow />
    </Router>
  );
}

RouteVariator.propTypes = {
  noRoute: PropTypes.bool,
  children: PropTypes.node,
  redirectUrl: PropTypes.string,
  activeSlug: PropTypes.string,
};
